import { useEffect, useState } from "react";

const SHOW_AFTER_PX = 200;

export const GoToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_PX);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div
      className="go-top"
      style={{ display: visible ? "block" : "none" }}
      role="button"
      tabIndex={0}
      title="Go to top"
      aria-label="Go to top"
      onClick={goTop}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          goTop();
        }
      }}
    />
  );
};
